module.exports = __webpack_public_path__ + "img/110cae4.png";